module.exports = __webpack_public_path__ + "static/media/chart.c97b7447.svg";